/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Toast_Save_FailedInputs */

const en_keyword_optimizer_toast_save_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't save your resume. Please try again.`)
};

const de_keyword_optimizer_toast_save_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf konnte nicht gespeichert werden. Bitte versuche es erneut.`)
};

const fr_keyword_optimizer_toast_save_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d'enregistrer votre CV. Veuillez réessayer.`)
};

const es_keyword_optimizer_toast_save_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo guardar tu CV. Inténtalo de nuevo.`)
};

const it_keyword_optimizer_toast_save_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile salvare il CV. Riprova.`)
};

const nl_keyword_optimizer_toast_save_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je CV kon niet worden opgeslagen. Probeer het opnieuw.`)
};

const pl_keyword_optimizer_toast_save_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się zapisać CV. Spróbuj ponownie.`)
};

const fi_keyword_optimizer_toast_save_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluetteloasi ei voitu tallentaa. Yritä uudelleen.`)
};

const da_keyword_optimizer_toast_save_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit CV kunne ikke gemmes. Prøv igen.`)
};

const sv_keyword_optimizer_toast_save_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditt CV kunde inte sparas. Försök igen.`)
};

/**
* | output |
* | --- |
* | "Couldn't save your resume. Please try again." |
*
* @param {Keyword_Optimizer_Toast_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_toast_save_failed = /** @type {((inputs?: Keyword_Optimizer_Toast_Save_FailedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Toast_Save_FailedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_toast_save_failed(inputs)
	if (locale === "fr") return fr_keyword_optimizer_toast_save_failed(inputs)
	if (locale === "es") return es_keyword_optimizer_toast_save_failed(inputs)
	if (locale === "it") return it_keyword_optimizer_toast_save_failed(inputs)
	if (locale === "nl") return nl_keyword_optimizer_toast_save_failed(inputs)
	if (locale === "pl") return pl_keyword_optimizer_toast_save_failed(inputs)
	if (locale === "fi") return fi_keyword_optimizer_toast_save_failed(inputs)
	if (locale === "da") return da_keyword_optimizer_toast_save_failed(inputs)
	if (locale === "sv") return sv_keyword_optimizer_toast_save_failed(inputs)
	return en_keyword_optimizer_toast_save_failed(inputs)
});